import { Link } from "@tanstack/react-router";
import { IKOMATCH_URL, trackIkomatchClick } from "./ikomatch-cta";

const legalLinks = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms-and-conditions", label: "Terms and Conditions" },
  { to: "/shipping-policy", label: "Delivery & Shipping Policy" },
  { to: "/refund-policy", label: "Cancellation & Refund Policy" },
  { to: "/contact", label: "Contact Us" },
] as const;

export function SiteFooter() {
  return (
    <footer className="border-t border-line bg-bg px-5 py-10 text-sm text-muted-ink">
      <div className="mx-auto grid max-w-[1120px] gap-8 md:grid-cols-3">
        <div>
          <div className="mb-3 flex items-center gap-2.5 text-base font-semibold text-ink">
            <span className="inline-block h-[22px] w-[22px] rounded-md bg-accent" />
            DeckScore
          </div>
          <p className="max-w-[320px] leading-relaxed">
            The always-on outreach engine - personalized cold emails to investors, written per investor, done for you:{" "}
            <a
              href={IKOMATCH_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackIkomatchClick("footer")}
              className="font-semibold text-accent"
            >
              ikomatch ↗
            </a>
          </p>
        </div>

        <div>
          <div className="mb-3 text-[13px] font-bold uppercase tracking-widest text-ink">
            Legal
          </div>
          <ul className="flex flex-col gap-2">
            {legalLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-ink">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/grants" className="hover:text-ink">
                Grants
              </Link>
            </li>
            <li>
              <Link to="/for-investors" className="hover:text-ink">
                For Investors
              </Link>
            </li>
          </ul>
        </div>


        <div>
          <div className="mb-3 text-[13px] font-bold uppercase tracking-widest text-ink">
            Contact
          </div>
          <address className="not-italic leading-relaxed">
            Adviselo Collab Studios Private Limited
            <br />
            Surat, Gujarat, India
            <br />
            <a href="mailto:info@ikomatch.com" className="hover:text-ink">
              info@ikomatch.com
            </a>
            <br />
            <a href="tel:+919723461686" className="hover:text-ink">
              +91 9723461686
            </a>
          </address>
        </div>
      </div>
      <div className="mx-auto mt-8 max-w-[1120px] border-t border-line pt-6 text-xs text-muted-ink">
        © {new Date().getFullYear()} Adviselo Collab Studios Private Limited. All rights reserved.
      </div>
    </footer>
  );
}
